var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-dashboard"},[_c('main',[_c('div',{staticClass:"left-panel"},[_c('SidebarMobile')],1),_vm._v(" "),_c('div',{staticClass:"right-panel"},[_c('HeaderMobile'),_vm._v(" "),_c('div',{staticClass:"right-panel-view"},[_c('router-view')],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b801d19","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Containers/LandingMobile.vue
// module id = null
// module chunks = 